export default {"src":"/_next/static/media/olark.e66246d5.gif","height":170,"width":300,"blurWidth":0,"blurHeight":0};